import { useWorkFormModalForm } from './useWorkFormModalForm';
import { useEmploymentRelationCatalog, useUpdateUserMutation, useUserQuery } from '../graphql';
import { useWorkOptions } from './useWorkOptions';

export const useController = ({
  onCompleted,
  onClose,
}) => {
  const { data, loading: loadingUser } = useUserQuery();
  const {
    data: catalogData,
    loading: loadingCatalog,
  } = useEmploymentRelationCatalog();

  const catalogs = catalogData?.catalogs || null;
  const user = data?.user || null;
  const requisition = data?.activeRequisition || null;
  const employmentName = requisition?.income?.employment?.name || null;

  const [updateUserMutation, { loading: isSubmitting }] = useUpdateUserMutation({
    onCompleted: () => {
      onCompleted();
      onClose();
    },
  });

  const {
    control,
    onSubmit,
    workingSectorIdValue,
  } = useWorkFormModalForm({
    user,
    updateUserMutation,
  });

  const {
    workingSectorOptions,
    workingActivitiesOptions,
  } = useWorkOptions({ workingSectorIdValue, catalogs });

  const loading = loadingUser || loadingCatalog;

  return {
    control,
    loading,
    onSubmit,
    isSubmitting,
    employmentName,
    workingSectorOptions,
    workingActivitiesOptions,
  };
};
